import type {IconType} from '@Components/icon-v2/icon.types';

export enum EntityThumbnailTileVariant {
  HALF = 'half',
  FULL = 'full',
}

export const ENTITY_THUMBNAIL_COUNT_BY_VARIANT: Record<EntityThumbnailTileVariant, number> = {
  [EntityThumbnailTileVariant.HALF]: 3,
  [EntityThumbnailTileVariant.FULL]: 6,
};

export interface EntityThumbnail {
  id: string;
  previewUrl: string;
  altText: string;
}

/** What a thumbnail shows on hover to say what clicking it does. */
export interface EntityThumbnailHoverAction {
  icon: string;
  iconType: IconType;
  label: string;
}

export interface EntityThumbnailTileViewMoreAction {
  label: string;
  icon: string;
  onClick: () => void;
}

export interface EntityThumbnailTileProps<TThumbnail extends EntityThumbnail> {
  title: string;
  subtitle: string;
  subtitleIcon: string;
  mobileSubtitle: string;
  illustrationUrl: string | null;
  thumbnails: TThumbnail[];
  minThumbnailsToRender: number;
  hoverAction: EntityThumbnailHoverAction;
  viewMoreAction: EntityThumbnailTileViewMoreAction;
  onThumbnailClick: (thumbnail: TThumbnail) => void;
  variant: EntityThumbnailTileVariant;
}
